/**
 * Api统一管理
 */
import http from './http'

export default {

  /**宅小取**/
  // 登录（宅小取）
  apiLogin(data) {
    return http.post('/staff/captchaLogin', data)
  },
  // permission 查询店员权限
  apiGetPermissions() {
    return http.get('/permission')
  },
  /**订单管理**/
  //线上订单转化为邮寄订单
  apiOrderConvent(data) {
    return http.post('/order/convert',data)
  },
  // 查询门店下拉框（老板门下所有门店）
  apiGetStoreList(data) {
    return http.get('/store/all', data)
  },
  // 获取品类下拉列表
  apiGetCategoryList(data) {
    return http.get('/store/category/list', data)
  },
  // 当前门店下店员
  apiGetStaffListByStore(data) {
    return http.get('/staff/byStore', data)
  },
  // 订单列表查询
  apiGetOrderList(data) {
    return http.get('/order/list', data)
  },
  // /order/otn/list 查询依旧换新订单
  apiGetOrderOtnList(data) {
    return http.get('/order/otn/list', data)
  },
  // /order/otn/upload/delete 删除以旧换新图片
  apiGetOrderOtndelete(data) {
    return http.del('/order/otn/upload/delete', data)
  },
  // 以旧换新结算 /order/otn/settle
  apiGetOrderOtnsettle(data) {
    return http.post('/order/otn/settle', data)
  },
  // 以旧换新上门 /order/otn/visit
  apiOrderOtnVisit(data) {
    return http.put('/order/otn/visit', data)
  },
  // /order/otn/details 查询依旧换新订单详情
  apiOrderOtndetails(data) {
    return http.get('/order/otn/details', data)
  },
  // 取消依旧换新订单/order/otn/cancel
  apiOrderOtnCancel(data) {
    return http.put('/order/otn/cancel', data)
  },
  // 取消订单（门店
  apiCancelOrderItem(data) {
    return http.post('/order/cancel', data)
  },
  // 称重结算
  apiWeighingSettleOrder(data) {
    return http.post('/order/weighingSettle', data)
  },
  // 派单（门店
  apiDispatchOrderItem(data) {
    return http.post('/order/dispatch', data)
  },
  // 删除线下订单
  apiDelOfflineOrder(data) {
    return http.del('/order/del', data)
  },
  // 订单详情信息
  apiGetOrderItemInfo(data) {
    return http.get('/order/details', data)
  },
  // 线下订单详情信息
  apiGetOffLineItemInfo(data) {
    return http.get('/order/offline/details', data)
  },
  //编辑完成订单信息
  apiUpdateItemInfo(data) {
    return http.post('/order/update', data)
  },
  //查询编辑订单记录
  apiGetUpdateLog(data) {
    return http.get('/order/update/log', data)
  },
  // 线下订单列表查询
  apiGetOffLineOrderList(data) {
    return http.get('/order/offline/list', data)
  },
  // 获取订单数量
  apiGetOrderNum(data) {
    return http.get('/order/count', data)
  },
  // 品类元素二级下拉列表
  apiGetOrderListTwo(data) {
    return http.get('/store/ce/select', data)
  },
  // 线下订单录入
  apiSubmitOrderItem(data) {
    return http.post('/order/input', data)
  },
  // 订单-删除图片
  apiDelPicForOrder(data) {
    return http.del('/order/upload/delete', data)
  },
  // 物流订单列表
  apiLogisticsDriverList(data) {
    return http.get('/logistics/manage/list', data)
  },
  //物流订单详情
  apiLogisticsDriverDetails(data) {
    return http.get("/logistics/manage/details", data)
  },


  /** 客户管理**/
  // 获取客户列表
  apiGetClientList(data) {
    return http.get('/user/list', data)
  },
  // 积分兑换
  apiExchangePoints(data) {
    return http.post('/user/points/offline/exchange', data)
  },


  // -----------------------------权限------------
  // 查询所有权限组
  permissionGroup(data) {
    return http.get('/permission/group', data)
  },
  // 查询所有权限
  permissionAll(data) {
    return http.get('/permission/all', data)
  },
  // 添加门店角色
  roleAdd(data) {
    return http.post('/role/add', data)
  },
  // 查询门店角色
  role(data) {
    return http.get('/role', data)
  },
  // 删除门店角色
  deleteRole(data) {
    return http.del('/deleteRole', data)
  },
  // 编辑角色权限
  selectPermission(data) {
    return http.post('/role/permission', data)
  },
  //  查询角色权限
  rolePermission(data) {
    return http.get('/role/permission', data)
  },

  // ---------------------员工模块---------------------
  // 添加员工
  staffAdd(data) {
    return http.post('/staff/add', data)
  },
  // 店员列表
  staffByList(data) {
    return http.get('/staff/list', data)
  },
  // 店员详情
  staffDetails(data) {
    return http.get('/staff/details', data)
  },
  // 上传收款码
  PostStaffQrCode(data) {
    return http.post('/staff/qrCode', data)
  },
  // 修改店员信息
  staffUpdate(data) {
    return http.post('/staff/update', data)
  },
  //删除店员图片
  staffdelete(data) {
    return http.del('image/delete', data)
  },

  // ----------------门店模块---------------
  // 查询门店下拉框（老板门下所有门店）
  storeAll(data) {
    return http.get('/store/all', data)
  },
  // 查询门店下拉框（员工门下管理门店）
  storeStaff(data) {
    return http.get('/store/staff', data)
  },

  // 查看店铺列表
  storeList(data) {
    return http.get('/store/list', data)
  },
  //查看分拣中心店铺列表
  apiStoreSortingCenterList(data) {
    return http.get('/store/sortingCenter/list', data)
  },

  // 查看店铺详情
  storeDetails(data) {
    return http.get('/store/details', data)
  },
  // 当前门店下店员
  staffByStore(data) {
    return http.get('/staff/byStore', data)
  },
  // 老板添加店铺
  addStore(data) {
    return http.post('/store', data)
  },
  //  编辑店铺
  updateStore(data) {
    return http.put('/store', data)
  },
  // 获取门店分布
  GetDistribution(data) {
    return http.get('/store/list/distribution', data)
  },
  // 门店上传收款码
  PostQrCode(data) {
    return http.post('/store/qrCode', data)
  },
  // ------------------品类----------
  // 获取品类下拉列表
  categoryList(data) {
    return http.get('/store/category/list', data)
  },
  // 品类元素二级下拉列表

  ceSelect(data) {
    return http.get('/store/ce/select', data)
  },

  // 添加品类
  addCategory(data) {
    return http.post('/store/category', data)
  },
  //  品类重命名
  upadetCategory(data) {
    return http.put('/store/category', data)
  },
  // 删除品类（只能删除没有添加元素的品类）
  delCategory(data) {
    return http.del('/store/category', data)
  },
  // --------------店铺元素模块-----------

  // 查看店铺元素
  selectelEment(data) {
    return http.get('/store/element', data)
  },

  // 给品类添加元素
  instElement(data) {
    return http.post('/store/element', data)
  },

  // 删除元素
  delElement(data) {
    return http.del('/store/element', data)
  },

  // 编辑元素
  UpadateElement(data) {
    return http.put('/store/element', data)
  },
  //  查看减碳量
  selectReduction(data) {
    return http.get('/store/element/reduction', data)
  },
  //
  // ---------------店铺重量----------
  // 查看店铺重量配置
  storeWeight(data) {
    return http.get('/store/weight', data)
  },
  // 新增店铺重量配置
  addWeight(data) {
    return http.post('/store/weight', data)
  },
  // 编辑店铺重量
  upadteWeight(data) {
    return http.put('/store/weight', data)
  },
  // ---------------------展示品类管理------------

  // 查看某一店铺配置的展示在首页的品类
  selecteXhibition(data) {
    return http.get('/store/exhibition/category', data)
  },
  // 添加展示某一品类与下面的最多8个小品类

  addExhibition(data) {
    return http.post('/store/exhibition/category', data)
  },
  // 删除某一品类的展示
  delExhibition(data) {
    return http.del('/store/exhibition/category', data)
  },
  // 移动品类展示位置
  upOrdownExhibition(data) {
    return http.post('/store/exhibition/category/move', data)
  },
  // ----------单位---------
  // 查询所有单位
  unit() {
    return http.get('/unit')
  },
  //----------- 店铺统计模块--------
  // 品类金额统计
  statisticsMoney(data) {
    return http.get('/store/statistics/category', data)
  },
  // 数量展示
  statisticsNumber(data) {
    return http.get('/store/statistics/number', data)
  },
  // 订单折线图
  orderLine(data) {
    return http.get('/store/statistics/order/line', data)
  },
  // 订单线上下数据列表
  GetOnOffline(data) {
    return http.get('/store/statistics/order/onOffline', data)
  },
  // 订单线上下数据
  GetRatio(data) {
    return http.get('/store/statistics/order/ratio', data)
  },
  //=------------- 经营分析模块 =-------------------
  // 交账趋势图
  GetapiBillTrend(data) {
    return http.get('/analysis/bill/trend', data)
  },
  // 顶部的经营分
  GetapiOperateInterest(data) {
    return http.get('/analysis/operate/interest', data)
  },
  // /analysis/operate/range/interest
  // 顶部的经营分(时间范围查询)
  GetapiOperateRangeInterest(data) {
    return http.get('/analysis/operate/range/interest', data)
  },
  // 经营趋势图
  GetapiOperateTrend(data) {
    return http.get('/analysis/operate/trend', data)
  },
  // 收货趋势
  GetapiReceiveTrend(data) {
    return http.get('/analysis/receive/trend', data)
  },
  // 查询成本
  GetapStoreiCost(data) {
    return http.get('/store/cost', data)
  },
  // 添加、修改成本通用接口
  PutapStoreiCost(data) {
    return http.put('/store/cost', data)
  },

  // 查询目标利润
  GetapTargetProfit(data) {
    return http.get('/store/targetProfit', data)
  },

  // 添加、修改利润通用接口
  PutTargetProfit(data) {
    return http.put('/store/targetProfit', data)
  },

  //  品类元素二级下拉列表（字符串）
  GetselectStr(data) {
    return http.get('/store/ce/selectStr', data)
  },
  // 海报添加
  PostSlogan(data) {
    return http.post("/store/slogan", data)
  },
  PutSlogan(data) {
    return http.put("/store/slogan", data)
  },
  // 海报查询
  GetSloganList(data) {
    return http.get("store/slogan/list", data)
  },


  DelSlogan(data) {
    return http.del('/store/slogan', data)
  },

  /**
   *
   * 光荣榜
   */
  // 个人
  ApiStaffNessageList(data) {
    return http.get("/achievement/rank/staff", data)
  },
  // 店铺
  ApiStoreNessageList(data) {
    return http.get("/achievement/rank/store", data)

  },
  /**
   * 店铺分组模块
   *
   */
  // 创建分组
  PostGroup(data) {
    console.log(data, "data")
    return http.post('/store/group', data)
  },
  // 编辑分组名称
  PutGroup(data) {
    return http.put('/store/group', data)
  },
  // 删除分组
  DelGroup(data) {
    return http.del('/store/group', data)
  },
  // 分组
  PostGroupExecute(data) {
    return http.post('/store/group/execute', data)
  },
  // 查看分组
  GetGroupList(data) {
    return http.get('/store/group/list', data)
  },
  //----------------统计------------
  // 骑手（店员）表单统计
  GetFormRider(data) {
    return http.get('/store/statistics/form/rider',data)
  },
// 物流表单统计
GetFormLogistics(data) {
  return http.get('/store/statistics/form/logistics',data)
},
// 分拣中心表单统计
GetFormSortingCenter(data) {
  return http.get('/store/statistics/form/sortingCenter',data)
},
// 中转仓表单统计
GetFormtransferStore(data) {
  return http.get('/store/statistics/form/transferStore',data)
},
// *------------碳中和小屋大屏数据------------
// 品类回收列表
GetCarbonCategoryList(data){
  return http.get("/store/statistics/carbon/category/list",data)
},
// 回收排行榜
GetRankingList(data){
  return http.get("/store/statistics/carbon/ranking/list",data)
},
// 今日回收数量
GetRecyclingList(data){
  return http.get("/store/statistics/carbon/recycling/list",data)
},
// 今日回收总量
GetRecyclingTotal(data){
  return http.get("/store/statistics/carbon/recycling/total",data)
},
//---------------------------审批--------------------------
//新增/编辑审批
Putapproval(data){
  return http.put("/approval/config",data)
},
//审批配置列表
GetapprovalList(data){
  return http.get("/approval/config/list",data)
},
//审批配置详情
GetApprovalConfigDetails(data){
  return http.get("/approval/config/details",data)
},
//-----------审批阶段---------
//审批列表
GetapprovalStageList(data){
  return http.get("/approval/list",data)
},
//阶段详情
GetapprovalDetails(data){
  return http.get("/approval/stage/details",data)
},
//获取审批数量
GetapprovalCount(){
  return http.get("/approval/count")
},
//审批
Postapproval(data){
  return http.post("/approval/examine",data)
},
//报销审批详情
GetConfigDetails(data){
  return http.get('/expense/details',data)
},
//查询审批数量
GetapprovalCount(data){
  return http.get("/approval/count",data)
},
}



// WEBPACK FOOTER //
// ./src/apiConfig/api.js